import { Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import { ProductGroups } from 'enums';
import PaiListItem from 'features/ui/base-components/pai-list-item';
import PaiButton from 'features/ui/base-components/pai-button';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';

interface Props {
  open: boolean;
  productGroup: ProductGroups;
  handleClose(): void;
}

const AddedTemplateSuccessDialog: React.FC<Props> = ({ open, handleClose, productGroup }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  // Helper function to handle product-specific translations
  const getLocalizedText = (key: string): string => {
    if (productGroup === ProductGroups.LEAD_BOOSTER) {
      const leadBoosterKey = `${key}_LeadBooster`;
      return t(leadBoosterKey) || t(key);
    }
    // Default is for Active Sourcing
    const activeSourcingKey = `${key}_ActiveSourcing`;
    return t(activeSourcingKey) || t(key);
  };

  return (
    <Dialog open={open} classes={{ paper: classes.paper }} fullWidth={true} maxWidth={'sm'}>
      <DialogTitle className={classes.title}>
        <Typography className={classes.titleText}>{t('addedTemplateTitle')}</Typography>
      </DialogTitle>
      <DialogContent className={classes.content}>
        <Typography className={classes.subTitle} mb={'16px'}>
          {t('addedTemplateSubtitle')}
        </Typography>
        <Stack gap={2}>
          <PaiListItem
            text={getLocalizedText('addedTemplateStep1')}
            subText={getLocalizedText('addedTemplateStep1Description')}
            disablePadding={true}
            highlight={true}
            size={'extra-large'}
          />
          <PaiListItem
            text={getLocalizedText('addedTemplateStep2')}
            subText={getLocalizedText('addedTemplateStep2Description')}
            disablePadding={true}
            highlight={true}
            size={'extra-large'}
          />
        </Stack>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <PaiButton text={t('ok')} border={'rounded'} size={'small'} action={handleClose} />
      </DialogActions>
    </Dialog>
  );
};

const useStyles = makeStyles()((theme) => ({
  paper: {
    borderRadius: '16px',
  },
  title: {
    background: 'linear-gradient(to right, #5044FF, #4AA4FF)',
  },
  titleText: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 'bold',
    textTransform: 'uppercase',
    color: '#FFF',
    textAlign: 'center',
  },
  content: {
    padding: '24px !important',
    whiteSpace: 'pre-wrap',
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '16px',
    padding: '0 24px 20px 24px',
  },
  subTitle: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 'bold',
  },
}));

export default AddedTemplateSuccessDialog;
